// Athlete Note Types

export type NoteType = 'general' | 'injury' | 'achievement' | 'observation' | 'program';

export interface AthleteNote {
  id: string;
  athlete_id: string;
  organization_id: string;
  assistant_id?: string;
  title: string;
  content: string;
  note_type: NoteType;
  /** Автор: сервер ставит пользователя входа (в запросе не передаётся) */
  created_by?: string;
  created_at: string;
  updated_at: string;
  /** Имя автора; пусто - автор не сохранён */
  author_name?: string;
  /** Смотрящий может править и удалять: автор или владелец клуба */
  can_edit?: boolean;
  deleted_at?: string;
}

/** Запись в корзине (GET .../notes/trash) */
export interface DeletedAthleteNote extends AthleteNote {
  deleted_at: string;
  deleted_by_name?: string;
  purge_at: string;
  can_restore?: boolean;
}

export interface CreateAthleteNoteRequest {
  assistant_id: string;
  title: string;
  content: string;
  note_type: NoteType;
}

export interface UpdateAthleteNoteRequest {
  title: string;
  content: string;
  note_type: NoteType;
}

export interface AthleteNotesResponse {
  notes: AthleteNote[];
  total: number;
  limit: number;
  offset: number;
}

// Иконки и лейблы для типов заметок
export const NOTE_TYPE_CONFIG: Record<NoteType, { icon: string; label: string; color: string }> = {
  general: {
    icon: '📝',
    label: 'Общее',
    color: '#F57C00', // Orange
  },
  injury: {
    icon: '🏥',
    label: 'Травма',
    color: '#E65100', // Dark orange
  },
  achievement: {
    icon: '🏆',
    label: 'Достижение',
    color: '#FFB74D', // Light orange
  },
  observation: {
    icon: '👁',
    label: 'Наблюдение',
    color: '#FB8C00', // Mid orange
  },
  program: {
    icon: '📋',
    label: 'Программа',
    color: '#FF9800', // Bright orange
  },
};
